module.exports = __webpack_public_path__ + "static/media/preparing-order.80187b29.jpg";